import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceSliceDTO } from './types'

export const WORKSPACE_PERFORMANCE_FRAGMENT: TypedDocumentNode<WorkspaceSliceDTO> = gql`
  fragment WorkspacePerformanceFragment on Workspace {
    users {
      id
      email
    }
    products {
      id
      product
      performanceReportUrl
    }
  }
`
